// 손님이 어느 네이버 스토어에서 왔는지 (2026-10-21 김현비).
// 스토어 상품 → 스토어별 블로그 글 → 쿠키스토리 로 들어오므로 출처(referrer)는 블로그가 된다.
// 그래서 블로그 링크에 꼬리표를 붙인다: cookistory.com/order?store=makerz | ?store=kkuk
// 어느 페이지로 들어오든 기억해 두었다가 [네이버 스토어에서 결제] 가 그 스토어 쿠키커터 상품으로 보낸다.
const KEY = "cookistoryStore";
const TTL_MS = 24 * 60 * 60 * 1000; // 하루 — 견적을 보고 나중에 결제하러 오는 손님도 같은 스토어로

export const STORE_PRODUCT_URL = {
  makerz: "https://smartstore.naver.com/3dmakerz/products/13821302222",
  kkuk: "https://smartstore.naver.com/kkuk-studio/products/13622693537",
};

export function rememberStoreFromSearch(search) {
  const store = new URLSearchParams(search || "").get("store");
  if (!store || !STORE_PRODUCT_URL[store]) return;
  try {
    localStorage.setItem(KEY, JSON.stringify({ store, expiresAt: Date.now() + TTL_MS }));
  } catch (e) {
    // localStorage 사용 불가(시크릿 모드 등) — 기본 스토어로 간다
  }
}

/** 기억해 둔 스토어의 쿠키커터 상품 주소. 없거나 만료면 null. */
export function rememberedStoreProductUrl() {
  try {
    const saved = JSON.parse(localStorage.getItem(KEY) || "null");
    if (saved && saved.expiresAt > Date.now() && STORE_PRODUCT_URL[saved.store]) return STORE_PRODUCT_URL[saved.store];
    if (saved) localStorage.removeItem(KEY);
  } catch (e) {
    // 파싱 실패 — 무시
  }
  return null;
}
